import React from 'react';

import { Container } from 'common/components/Layout/Layout';

import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

import styles from './MissionAndVisionPlaceholder.module.scss';

const MissionAndVisionPlaceholder = () => (
  <div className={styles.BackgroundContainer}>
    <Container>
      <div className={styles.BigInfoBox}>
        <ContentBar className={styles.InfoBoxLogo} />
        <TextBlock
          color={styles.PlaceholderDefaultColor}
          className={styles.InfoBoxTitle}
          rows={1}
        />
        <TextBlock
          color={styles.PlaceholderDefaultColor}
          className={styles.InfoBoxText}
          rows={5}
        />
        <TextBlock
          color={styles.PlaceholderDefaultColor}
          className={styles.InfoBoxText}
          rows={5}
        />
      </div>
      <div className={styles.BigInfoBox}>
        <ContentBar className={styles.InfoBoxLogo} />
        <TextBlock
          color={styles.PlaceholderDefaultColor}
          className={styles.InfoBoxTitle}
          rows={1}
        />
        <TextBlock
          color={styles.PlaceholderDefaultColor}
          className={styles.InfoBoxText}
          rows={5}
        />
        <TextBlock
          color={styles.PlaceholderDefaultColor}
          className={styles.InfoBoxText}
          rows={5}
        />
      </div>
    </Container>
  </div>
);

export default MissionAndVisionPlaceholder;



// WEBPACK FOOTER //
// ./src/views/MissionAndVision/placeholder/MissionAndVisionPlaceholder.js